/** Feature flags for controlling visibility of various components */
export type FeatureFlagsType = {
  readonly SHOW_DAYCARE_RECRUITMENT_BANNER: boolean;
  readonly SHOW_FOOTER_BANNER: boolean;
  readonly ENABLE_KOEKAKE_TRIAL: boolean;
  readonly ENABLE_DIAGNOSIS_REPORT_PURCHASE: boolean;
  readonly SHOW_CLASS_TIMETABLE: boolean;
  readonly SHOW_DAYCARE_ADMISSION_CONSIDERATION: boolean;
};

export const FeatureFlags: FeatureFlagsType = {
  /** 保育園募集バナーの表示フラグ */
  SHOW_DAYCARE_RECRUITMENT_BANNER: false,
  /** フッターバナーの表示フラグ */
  SHOW_FOOTER_BANNER: true,
  /** 診断結果→モンテチャット try 導線（声かけ無料体験）の表示フラグ。ミニレポートCTA（PMF検証）への集中のため一時OFF */
  ENABLE_KOEKAKE_TRIAL: false,
  /** 診断結果ページのミニレポート単発購入CTA（PMF検証）の表示フラグ */
  ENABLE_DIAGNOSIS_REPORT_PURCHASE: true,
  /** classページ教室情報の時間割の表示フラグ。現在は金曜日のみの開講で時間割が意味を持たないため一時OFF。開講日を増やす際にONへ戻す */
  SHOW_CLASS_TIMETABLE: false,
  /** daycare/admission の「入園をご検討中の方へ」セクション（体験クラス・伴走クラス・優先入園の案内）の表示フラグ。一時OFF。再開時にONへ戻す */
  SHOW_DAYCARE_ADMISSION_CONSIDERATION: false,
};
